export class Reserve {
    Name: string;
    Email: string;
    PhoneNo: string;
    Member: string;
    VisitingDate: Date;
    VisitingTime: string;
    Message: string;
    Captcha: string;
    Members_child: string;
    Accommodation: string;
    LastName: string;
    CheckOutDate: string;
    CheckInDate: string = '';
}

export class Reservations {
    RESERVATION_NAME: any;
    RESERVATION_TITLE: any='';
    RESERVATION_EMAIL: any;
    RESERVATION_MOBILE_NO: any;
    RESERVATION_NO_OF_MEMBER: any='';
    RESERVATION_NO_OF_CHILD: any='';
    RESERVATION_SPECIAL_REQUEST: any;
    RESERVATION_CHECK_IN_DATE: any;
    RESERVATION_CHECK_OUT_DATE: any;
    RESERVATION_NO_OF_DAYS: any;
    RESERVATION_ADVANCE_AMT: any;
}


